import { Injectable } from '@angular/core';
import { Invencexpmate } from "../invinterfaces/invencexpmate";
import { Invdetexpmate } from "../invinterfaces/invdetexpmate";
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { Trnexpmatmp } from "../invinterfaces/trnexpmatmp";
import { Trnexpmatac } from "../invinterfaces/trnexpmatac";

@Injectable({
  providedIn: 'root'
})
export class InvexpmaterialesService {
  public url: string;
  public way: string;
  public wayrep : string
  public encexpmate: Invencexpmate[] = [];
  public detexpmatearray: Invdetexpmate[][] = [];
  public hmpConfiguracion: any[];
  public trnexpmatmp: Trnexpmatmp[] = []
  public trnexpmatac: Trnexpmatac[] = []
  public decimalesCantidadart = 2
  constructor(
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private init: NuevoComponentService,
    private confIniciales: ConfInicialesService
  ) {
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
    this.wayrep = sessionStorage.getItem('wayrep');
  }

  procesarcobertura(item) {
    return this.http.post<any[]>(this.wayrep + '/inventario/explosionmate/19de18ee2b6cc300000000', {
      elementos: {
        p_fecha_desde: item.ENCEXPMAT_FECHAINI,
        p_fecha_hasta: item.ENCEXPMAT_FECHAFIN,
        p_cobertura: Number(item.ENCEXPMAT_COBERTURA),
        p_periodos: Number(item.ENCEXPMAT_PERIODO),
        p_com_codigo: '01',
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarencexpmate(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/4afc76faa75d90', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_encexpmat_cobertura: Number(item.ENCEXPMAT_COBERTURA),
        p_encexpmat_fechaini: item.ENCEXPMAT_FECHAINI,
        p_encexpmat_fechafin: item.ENCEXPMAT_FECHAFIN,
        p_encexpmat_periodo: Number(item.ENCEXPMAT_PERIODO),
        p_usuidentificacion:this.usuario.identificacion,
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertardetexpmate(item: Invdetexpmate) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/4afc76faa6bbb0', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_detexpmat_codigo: item.DETEXPMAT_CODIGO,
        p_detexpmat_descripcion: item.DETEXPMAT_DESCRIPCION,
        p_detexpmat_cobertura: item.DETEXPMAT_COBERTURA,
        p_detexpmat_ventatotal: item.DETEXPMAT_VENTATOTAL,
        p_detexpmat_venprommen: item.DETEXPMAT_VENPROMMEN,
        p_detexpmat_invreal: item.DETEXPMAT_INVREAL,
        p_detexpmat_undpendientes: item.DETEXPMAT_UNDPENDIENTES,
        p_detexpmat_cantsugept: item.DETEXPMAT_CANTSUGEPT,
        p_detexpmat_cantsugekg: item.DETEXPMAT_CANTSUGEKG,

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultarencexpmate(codigo) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/662fcf57aa75d80', {
      elementos: {
        p_encexpmat_codigo: codigo,
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultardetexpmate(codigo) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/662fcf57aa6bbc0', {
      elementos: {
        p_encexpmat_codigo: codigo,
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarcobertura(codigo) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/3ab2b4aea75d8e', {
      elementos: {
        p_encexpmat_codigo: codigo,
        p_com_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarlineadet(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/7565695d5b6bbc0', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_detexpmat_codigo: item.DETEXPMAT_CODIGO
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultartrnexpmatmp(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/cc5f9eaf55bef000', {
      elementos: {
        p_encexpmat_codigo: item,
        p_com_codigo: '01',

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultartrnexpmatmpini(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/cc5f9eaf55dfgtf000', {
      elementos: {
        p_encexpmat_codigo: item,
        p_com_codigo: '01',

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultartrnexpmatac(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/cc5f9eaf987bef000', {
      elementos: {
        p_encexpmat_codigo: item,
        p_com_codigo: '01',

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultartrnexpmatacini(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/cc5f934er55bef000', {
      elementos: {
        p_encexpmat_codigo: item,
        p_com_codigo: '01',

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  guardardetallemp(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/43cadb55beeef0', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_expmatmp_codigo: item.EXPMATMP_CODIGO,
        p_expmatmp_descripcion: item.EXPMATMP_DESCRIPCION,
        p_expmatmp_cantsugkg: item.EXPMATMP_CANTSUGKG,
        p_art_codigo: item.ART_CODIGO,

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizardetallemp(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/299df2ab2', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_expmatmp_codigo: item.EXPMATMP_CODIGO,
        p_expmatmp_descripcion: item.EXPMATMP_DESCRIPCION,
        p_expmatmp_cantsugkg: item.EXPMATMP_CANTSUGKG,
        p_art_codigo: item.ART_CODIGO,

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarMP(codigo) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/7565695d5beef00', {
      elementos: {
        p_encexpmat_codigo: codigo,
        p_com_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  guardardetalleac(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/43cadb55befgtf0', {
      elementos: {
        p_encexpmat_codigo :item.ENCEXPMAT_CODIGO ,
        p_com_codigo :'01',
        p_trnexpmatac_codigo :item.TRNEXPMATAC_CODIGO,
        p_trnexpmatac_descripcion :item.TRNEXPMATAC_DESCRIPCION,
        p_trnexpmatac_cantsugund:  item.TRNEXPMATAC_CANTSUGUND,
        //p_art_codigo :item.ART_CODIGO,

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizardetalleac(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/29976htydf2ab2', {
      elementos: {
        p_encexpmat_codigo :item.ENCEXPMAT_CODIGO ,
        p_com_codigo :'01',
        p_trnexpmatac_codigo :item.TRNEXPMATAC_CODIGO,
        p_trnexpmatac_descripcion :item.TRNEXPMATAC_DESCRIPCION,
        p_trnexpmatac_cantsugund:  item.TRNEXPMATAC_CANTSUGUND,
        //p_art_codigo :item.ART_CODIGO,

      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarAC(codigo) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/756569trbeef00', {
      elementos: {
        p_encexpmat_codigo: codigo,
        p_com_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calcularakg(item,cantidad) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/18aab3d556d8ac000000000', {
      elementos: {
        p_art_codigo :item,
        p_cant_sug_und  :cantidad,
        p_com_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarlineadetac(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/eacad2bab6d77800', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_trnexpmatac_codigo: item.TRNEXPMATAC_CODIGO
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarlineadetmp(item) {
    return this.http.post<any[]>(this.way + '/inventario/explosionmate/eacad2bab6df67800', {
      elementos: {
        p_encexpmat_codigo: item.ENCEXPMAT_CODIGO,
        p_com_codigo: '01',
        p_expmatmp_codigo: item.EXPMATMP_CODIGO
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
